import {
  Tabs,
  TabList,
  Tab,
  TabPanels,
  TabPanel,
  useMediaQuery,
} from "@chakra-ui/react";
import { useContext } from "react";
import CommoditiesTable from "../../components/tables/CommoditiesTable";
import RequestsTable from "../../components/tables/RequestsTable";
import UsersTable from "../../components/tables/UsersTable";
import { AuthContext } from "../../context/AuthContext";
import UserLayout from "../../layout/UserLayout";

type Props = {};
// chakra-dayzed-datepicker

const UserPageContainer = (props: Props) => {
  const { auth } = useContext(AuthContext);
  const [isLargerThan900] = useMediaQuery("(min-width: 900px)");

  return (
    <UserLayout>
      {auth.role === "ESTABLISHMENT" ? (
        <Tabs align="end" variant="enclosed" isFitted={!isLargerThan900} p="2">
          <TabList>
            <Tab _selected={{ color: "white", bg: "primary" }}>Commodities</Tab>
            <Tab _selected={{ color: "white", bg: "primary" }}>Users</Tab>
            {/* <Tab _selected={{ color: "white", bg: "primary" }}>Requests</Tab> */}
          </TabList>
          <TabPanels>
            <TabPanel>
              <CommoditiesTable />
            </TabPanel>
            <TabPanel>
              <UsersTable />
            </TabPanel>
            {/* 
            <TabPanel>
              <RequestsTable />
            </TabPanel> */}
          </TabPanels>
        </Tabs>
      ) : (
        <CommoditiesTable />
      )}
    </UserLayout>
  );
};

export default UserPageContainer;
